<div class="row" style="margin-top: 20px">
  <div class="col-xs-12">
    <div class="controls-container">
      <mat-form-field appearance="fill">
        <mat-label>Month and Year</mat-label>
        <input matInput [matDatepicker]="dp" [formControl]="date" />
        <mat-datepicker-toggle matSuffix [for]="dp"></mat-datepicker-toggle>
        <mat-datepicker
          #dp
          startView="multi-year"
          (yearSelected)="chosenYearHandler($event)"
          (monthSelected)="chosenMonthHandler($event, dp)"
          panelClass="example-month-picker">
        </mat-datepicker>
      </mat-form-field>

      <button
        mat-raised-button
        color="primary"
        (click)="exportToExcel()"
        [disabled]="isLoading || dataSource.data.length === 0"
        style="margin-left: 10px">
        Export to Excel
      </button>
    </div>

    <div class="mat-elevation-z8 table-container">
      <table mat-table [dataSource]="dataSource">
        <!-- Agent Column -->
        <ng-container matColumnDef="agent">
          <th mat-header-cell *matHeaderCellDef>Row Labels</th>
          <td mat-cell *matCellDef="let row">{{ row.agentUsername }}</td>
          <td mat-footer-cell *matFooterCellDef>Grand Total</td>
        </ng-container>

        <!-- C Column -->
        <ng-container matColumnDef="C">
          <th mat-header-cell *matHeaderCellDef>C</th>
          <td mat-cell *matCellDef="let row">{{ row.change || '' }}</td>
          <td mat-footer-cell *matFooterCellDef>{{ footerData.change }}</td>
        </ng-container>

        <!-- COL Column -->
        <ng-container matColumnDef="COL">
          <th mat-header-cell *matHeaderCellDef>COL</th>
          <td mat-cell *matCellDef="let row">{{ row.collect || '' }}</td>
          <td mat-footer-cell *matFooterCellDef>{{ footerData.collect }}</td>
        </ng-container>

        <!-- E Column -->
        <ng-container matColumnDef="E">
          <th mat-header-cell *matHeaderCellDef>E</th>
          <td mat-cell *matCellDef="let row">{{ row.erect || '' }}</td>
          <td mat-footer-cell *matFooterCellDef>{{ footerData.erect }}</td>
        </ng-container>

        <!-- R Column -->
        <ng-container matColumnDef="R">
          <th mat-header-cell *matHeaderCellDef>R</th>
          <td mat-cell *matCellDef="let row">{{ row.reerect || '' }}</td>
          <td mat-footer-cell *matFooterCellDef>{{ footerData.reerect }}</td>
        </ng-container>

        <!-- STR Column -->
        <ng-container matColumnDef="STR">
          <th mat-header-cell *matHeaderCellDef>STR</th>
          <td mat-cell *matCellDef="let row">{{ row.stray || '' }}</td>
          <td mat-footer-cell *matFooterCellDef>{{ footerData.stray }}</td>
        </ng-container>

        <!-- Total Column -->
        <ng-container matColumnDef="total">
          <th mat-header-cell *matHeaderCellDef>Grand Total</th>
          <td mat-cell *matCellDef="let row">{{ row.total }}</td>
          <td mat-footer-cell *matFooterCellDef>{{ footerData.total }}</td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
        <tr mat-footer-row *matFooterRowDef="displayedColumns"></tr>

        <!-- Row shown when there is no matching data. -->
        <tr class="mat-row" *matNoDataRow>
          <td class="mat-cell" colspan="7">No data for selected month</td>
        </tr>
      </table>
      <div
        *ngIf="isLoading"
        style="
          display: flex;
          justify-content: center;
          align-items: center;
          padding: 20px;
        ">
        <mat-spinner diameter="40"></mat-spinner>
      </div>
    </div>
  </div>
</div>
